import Vue from 'vue';
import App from './App.vue';

import axios from 'axios';
import router from './router';
import store from './store';

// Alpha [开发环境]; Beta [测试环境]; Preview [预发布环境]; Online [正式环境]
const RE = "Online";
const DEBUG = RE != 'Online';
const SERVER_ADDR = (re => {
    switch(re) {
        case 'Alpha':
            return '/develop';
        case 'Beta':
            return '/test';
        case 'Preview':
            return '/pre';
        case 'Online':
            return '/api';
    }
})(RE);
const OSS_ADDR = 'https://cdn.yunchange.com/app_static/base';

// 引入element-ui
import {DatePicker, ColorPicker} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(DatePicker);
Vue.use(ColorPicker);

// 挂载全局公共方法
import global from './assets/script/function';

// 挂载自定义组件
import customComp from './components';
Vue.use(customComp);

// 挂载动态组件
import dynamicComp from './components/dynamic';
Vue.use(dynamicComp);

import shortcuts from './assets/script/shortcuts'

// 挂载子项目组件
import subComps from '@/submodule/components';
Vue.use(subComps, {
	$message: opt => {
		app.$message(opt)
	},
	$confirm: opt => {
		app.$confirm(opt)
	},
	$upload: opt => {
		app.uploadFile(opt);
	}
});

Vue.prototype.$bus = new Vue();

// request请求方法
Vue.prototype.request = function(config) {
	config = Object.assign({
		method: 'post',
		data: {},
		success: () => {},
		fail: () => {},
		complete: () => {},
	}, config);
	
	const param = config.data;
	config.data = global.encryption(config.data);
	config.data.session = store.state.session;

	if (config.method == 'get') {
		config.params = config.data;
		delete config.data;
	}

	config.loading && this.$loading();

	const source = axios.CancelToken.source();

	axios.create({
		baseURL: SERVER_ADDR,
		cancelToken: source.token
	})(config).then(res => {
		config.loading && this.$loadOver();

		if (config.responseType == 'blob') {
			config.success(res);
			return;
		}

		try {
			const data = global.deciphering(res.data.ciphertext);
			DEBUG && console.group(`----- success ${config.url.split('?')[0]} -----`);
			DEBUG && console.log('@param', param);
			DEBUG && console.log('@return', data);

			try {
				if (data.code == 405 || data.code == 403) {
					// 登录超时
					this.loginTimeout();

					for (let i in axios.requestQueue) {
						axios.requestQueue[i].abort();
					}
					axios.requestQueue = {};
				} else {
					delete axios.requestQueue[request.index];

					if (data.code == 200) {
						// 请求成功
						config.success && config.success(data.obj, data.message);
					} else {
						// 请求失败
						if (!config.fail || config.fail(data.code, data.obj, data.message) !== false) {
							this.$message({
								text: data.message || '请求失败',
								icon: 'fail'
							});
						}
					}
				}
			} catch (e) {
				this.$message({
					text: '系统出现未知异常',
					icon: 'fail'
				});
				DEBUG && console.error(e);
			}
				
			config.complete && config.complete(data.code, data.obj, data.message);
			config.response && config.response(data);
		} catch(e) {
			DEBUG && console.group(`----- error ${config.url.split('?')[0]} -----`);
			DEBUG && console.log('@param', param);
			DEBUG && console.log('@return', res);

			if (!config.fail || config.fail() !== false) {
				this.$message({
					text: '服务器出现未知异常',
					icon: 'fail'
				});
			};
		}
		DEBUG && console.log(`----- end ${config.url.split('?')[0]} -----`);
		DEBUG && console.groupEnd();
	}).catch(e => {
		config.loading && this.$loadOver();
		if (e.message == 'cancel') return;
		this.$message({
			text: '网络出现未知异常',
			icon: 'fail'
		});
	});

	if (!axios.requestQueue) {
		axios.requestIndex = 0;
		axios.requestQueue = {};
	}

	const request = {
		index: axios.requestIndex++,
		abort() {
			source.cancel('cancel');
		}
	};

	axios.requestQueue[request.index] = request;

	return request;
};

Vue.prototype.download = function(opt) {
	this.request({
		method: 'get',
		url: opt.url,
		responseType: 'blob',
		loading: opt.loading || true,
		success: res => {
			const blob = new Blob([res.data], {type: res.data.type});
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = opt.fileName || '未命名文件';
			link.click();
			window.URL.revokeObjectURL(link.href);
		}
	});
};

// 选择图片视频
Vue.prototype.selectMedia = function(opt) {
	app.$selectFile(opt);
};

// 选择跳转链接
Vue.prototype.selectLink = function(value, opt) {
	app.$selectLink(value, opt);
};

// 上传文件
Vue.prototype.uploadFile = function(opt) {
	app.$children[0].upload(opt);
};

// 复制至剪贴板
Vue.prototype.clipboard = function(text) {
	app.$children[0].clipboard(text);
};

// 登录失效提示
Vue.prototype.loginTimeout = function() {
	if (!window.$loginTimeoutConfirm) {
		window.$loginTimeoutConfirm = true;
		window.$loadingObj && window.$loadingObj.close();
		this.$confirm({
			text: '登录状态已失效，请重新登录',
			buttonName: '重新登录',
			cancelButton: false,
			resolve: () => {
				app.$store.commit('setSession', '');
				app.navigateTo('/login');
				delete window.$loginTimeoutConfirm;
			}
		});
	}
};

Vue.prototype.parsePixel = function(size) {
	if (parseInt(size) == size) {
		return parseInt(size) + 'px';
	}
	return size;
};

Vue.prototype.oss = function(url, w, h) {
	if (!url) return '';
	if (url.indexOf('http') != 0) {
		url = OSS_ADDR + url;
	}
	return `${url}?x-oss-process=image${h || w ? '/resize' : ''}${h ? ',h_'+h : ''}${w ? ',w_'+w : ''}/quality,q_80`;
};

Date.prototype.format = function(fmt) {
	var o = {
		'M+': this.getMonth() + 1, //月份
		'd+': this.getDate(), //日
		'h+': this.getHours(), //小时
		'm+': this.getMinutes(), //分
		's+': this.getSeconds(), //秒
		'q+': Math.floor((this.getMonth() + 3) / 3), //季度
		S: this.getMilliseconds(), //毫秒
	};

	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(this.getFullYear() + '').substr(4 - RegExp.$1.length)
		);
	}

	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length == 1
					? o[k]
					: ('00' + o[k]).substr(('' + o[k]).length)
			);
		}
	}

	return fmt;
};

window.cDialogZIndex = 110;

Vue.config.productionTip = false;

Vue.prototype.$busCatch = {}

const app = window.$app = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
